import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import FormCheckBoxWithLabel from '../legacyForm/FormCheckBoxWithLabel';

const required = value => value ? undefined : 'Pole jest wymagane';

const VoterApproval = ({ respondentProfile, privacyDataProcessingPolicyApprovalRequired, gdprApprovalRequired, termsAndConditionsApprovalRequired, disabled, tenantName }) => (
  <div style={{marginTop: 16}}>
    {privacyDataProcessingPolicyApprovalRequired ? <div>
      <Field
        name="privacyDataProcessingPolicyApproval"
        component={FormCheckBoxWithLabel}
        label={`Wyrażam zgodę na przetwarzanie moich danych osobowych podanych w formularzu w zakresie: ${respondentProfile.map(p => p.name).join(', ')} w celu wzięcia udziału w Konsultacjach Społecznych przeprowadzanych przez ${tenantName}`}
        fullWidth
        validate={required}
        disabled={disabled}
        type="checkbox"
      />
    </div> : null}
    {gdprApprovalRequired && <div>
      <Field
        name="gdprApproval"
        component={FormCheckBoxWithLabel}
        label={<div>Oświadczam, że Administrator Danych spełnił ciążący na nim obowiązek informacyjny oraz, że zapoznałem/am się z <a href="/polityka-prywatnosci" target="_blank" rel="noopener noreferrer">Polityką prywatności</a></div>}
        fullWidth
        validate={required}
        disabled={disabled}
        type="checkbox"
      />
    </div>}
    {termsAndConditionsApprovalRequired && <div>
      <Field
        name="termsAndConditionsApproval"
        component={FormCheckBoxWithLabel}
        label={<div>Zapoznałem/am się i akceptuję postanowienia <a href="/regulamin" target="_blank" rel="noopener noreferrer">Regulaminu</a></div>}
        fullWidth
        validate={required}
        disabled={disabled}
        type="checkbox"
      />
    </div>}
  </div>
);

VoterApproval.propTypes = {
  respondentProfile: PropTypes.array.isRequired,
  privacyDataProcessingPolicyApprovalRequired: PropTypes.bool,
  gdprApprovalRequired: PropTypes.bool,
  termsAndConditionsApprovalRequired: PropTypes.bool,
  disabled: PropTypes.bool,
  tenantName: PropTypes.string,
};

export default VoterApproval;



// WEBPACK FOOTER //
// ./src/components/consultationSurveys/VoterApproval.js